// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"tE-z","smallCardRow":"uE-z","largeCardRow":"vE-z","productSearchRow":"wE-z","curatedRow":"xE-z"};